var _rect, _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.00585938,
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4130_6407)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4130_6407",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 4,
    width: 15,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0059 4.84375H5.00586V19.1588H19.0059V4.84375Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4130_6407)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3378 10.9021L18.5496 4.84375H17.3145L12.7891 10.1041L9.17469 4.84375H5.00586L10.4716 12.7983L5.00586 19.1514H6.24096L11.0199 13.5963L14.837 19.1514H19.0059L13.3375 10.9021H13.3378ZM11.6461 12.8684L11.0923 12.0763L6.68599 5.77352H8.58303L12.139 10.8601L12.6928 11.6522L17.3151 18.2639H15.4181L11.6461 12.8687V12.8684Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4130_6407"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14.315,
    fill: "white",
    transform: "translate(5.00586 4.84375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.7582816c565b1de02f140a0215779950.svg";
export { ForwardRef as ReactComponent };